import { IComponentOptions, IController, IFormController } from 'angular';
import { UserService } from '../../../core/services/user/user.service';
import { StateService } from '@uirouter/angularjs';
import { ToastrService } from '../../../core/services/toastr/toastr.service';
import './delete-account-modal.component.scss';

class DeleteAccountModalCtrl implements IController {
  static $inject = [
    'UserService',
    '$state',
    'ToastrService'
  ];
  onClose: ( $event ) => void;
  data: any;
  username: string;
  password: string;
  form: IFormController;
  serverError: string;
  loading = false;

  constructor( private userService: UserService,
               private $state: StateService,
               private toastrService: ToastrService ) {
  }

  $onInit() {
  }

  submit() {
    this.serverError = null;
    if ( this.form.$valid ) {
      this.loading = true;
      this.userService.deleteUser(this.username, this.password)
        .then(() => {
          this.loading = false;
          this.toastrService.info('Account was deleted');
          this.closeModal(null);
          this.$state.go('logout');
        })
        .catch(( err ) => {
          console.log(err);
          this.loading = false;
          if ( err.data && err.data.text ) {
            this.serverError = err.data.text;
            return;
          }
          this.serverError = err.message || JSON.stringify(err);
        });
    }
  }

  closeModal( result: boolean ) {
    this.onClose({ result });
  }
}

export const DeleteAccountModalComponent: IComponentOptions = {
  controller: DeleteAccountModalCtrl,
  template: require('./delete-account-modal.component.html'),
  bindings: {
    data: '<',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/components/modals/delete-account-modal/delete-account-modal.component.ts